<script>
  export let hashbang = true
  import page from "page.js"
  import { setContext, afterUpdate } from "svelte"
  import { current_path } from "../etc/store.js"

  setContext("current_path", current_path)

  //   function navigate(ctx, next) {
  //     alert(`Navigating to: ${ctx.path}`)

  //     $current_path = ctx.path
  //   }
  //   page("/", navigate)
  //   page("/about", navigate)
  //   page("/news", navigate)

  let started = false
  afterUpdate(() => {
    if (!started) {
      started = true
      page("*", (ctx) => {
        $current_path = ctx.path
        console.log("PATH NOT FOUND: " + $current_path + "; Redirecting to 404")
        $current_path = "/404"
      })
      page.start({ hashbang })
    }
  })
</script>

<slot />
